import React from 'react';
import { ChatList } from 'react-chat-elements';
import 'react-chat-elements/dist/main.css';
import { usePage } from '@inertiajs/react';

export default function ThreadList({ threads, onThreadSelect, activeThreadId }) {
    const { auth } = usePage().props;
    const currentUser = auth.user;

    const chatListDataSource = threads.map(thread => {
        // Backend now only sends other participants, so just take the first one
        const otherParticipant = thread.users[0];
        
        // Build the data object conditionally
        const chatItem = {
            key: thread.id,
            id: thread.id,
            title: otherParticipant ? otherParticipant.name : '[Deleted User]',
            subtitle: thread.latest_message ? thread.latest_message.body : 'No messages yet.',
            date: new Date(thread.updated_at),
            unread: 0,
        };
        
        // Only add avatar if the user has a profile photo
        if (otherParticipant?.profile_photo_path) {
            chatItem.avatar = otherParticipant.profile_photo_path;
        }
        
        return chatItem;
    });

    return (
        <ChatList
            className='chat-list'
            dataSource={chatListDataSource}
            onClick={(chatItem) => onThreadSelect(chatItem.id)}
            active={activeThreadId}
        />
    );
}
